import { Component, Input } from '@angular/core';
import { NgForage } from 'ngforage';
import AssetHelper from 'src/app/helpers/asset-helper';
import Asset from 'src/app/model/asset';
import { ModalService } from 'src/app/services/modal.service';
import { SnackService } from 'src/app/services/snack.service';
import { SignAssociation } from '../sign-association';
import { SignAssociationAsset } from '../sign-association-asset';
import { FileHelper } from '../../../../../helpers/file-helper';

@Component({
  selector: 'association-examples',
  templateUrl: './association-examples.component.html',
  styleUrls: ['./association-examples.component.scss'],
})
export class AssociationExamplesComponent {
  @Input()
  assocObject: SignAssociation;

  isImage = FileHelper.isImage;

  constructor(
    private modalService: ModalService,
    private snackService: SnackService,
    private ngForage: NgForage
  ) {}

  getAssetClass(
    signStickerAsset: SignAssociationAsset,
    first: boolean
  ): string {
    if (!signStickerAsset.archived) {
      return first ? 'loadedImg' : 'loadedImg asset-left-space';
    }
    return '';
  }

  removeOnlineFile(index: number): void {
    this.modalService.confirmDialog(
      'Bestand verwijderen',
      'Bent u zeker dat u dit bestand wilt verwijderen?',
      () => {
        this.assocObject.examples.splice(index, 1);
        this.snackService.showSuccess(
          'Bestand zal verwijderd worden tijdens opslaan'
        );
      }
    );
  }

  removeOfflineFile(item: Asset, index: number) {
    this.modalService.confirmDialog(
      'Bestand verwijderen',
      'Bent u zeker dat u dit bestand wilt verwijderen?',
      () => {
        this.assocObject.offlineExamples.splice(index, 1);
        this.ngForage.removeItem(
          AssetHelper.getStorageKeyFor(item.localFileUuid)
        );
        this.snackService.showSuccess('Bestand succesvol verwijderd');
      }
    );
  }

  onAssetsAdded(assets: Asset[]): void {
    if (!this.assocObject.offlineExamples) {
      this.assocObject.offlineExamples = [];
    }
    assets.forEach((a) => {
      this.assocObject.offlineExamples.push(a);
    });
  }
}
